import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Container = styled(motion.div)<any>`
  @media only screen and (min-width: 768px) {
    width: 66%;
  }

  @media only screen and (max-width: 850px) {
    width: 100%;
  }

  align-self: center;
`;
